export default {
	"exchange.CannotExceed20Characters": "不能超过20个字符",
	"exchange.PleaseEnterTheRedemptionCode": "请输入兑换码",
	"exchange.TheRedemptionCodeIsNotLegitimate": "兑换码不合法",
	"exchange.PleaseEnterTheActivationCodeToRedeemTheProduct": "请输入激活码兑换商品",
	"exchange.RedeemNow": "立即兑换",
	"exchange.TheRedemptionCodeIsAContentRedemptionVoucherObtainedFromAThirdParty": "兑换码是从第三方获取的内容兑换凭证，",
	"exchange.CanBeRedeemedForTheCorrespondingGoods": "可兑换相应的商品",
	"exchange.IfYouHaveAnyQuestionsPleaseContactCustomerService": "如有疑问,请联系客服 >"
}